import React, { useState } from 'react';
import emailjs from '@emailjs/browser';
import { FaEnvelope, FaPhone, FaMapMarkerAlt, FaGithub, FaLinkedin, FaTwitter, FaInstagram, FaPaperPlane } from 'react-icons/fa';
import '../styles/Contact.css';

const contactInfo = [
  { icon: 'email', title: 'Email', value: 'atharvunwale38@gmail.com' },
  { icon: 'phone', title: 'Phone', value: '+91 8269481880' },
  { icon: 'location', title: 'Location', value: 'Indore, Madhya Pradesh' }
];

const socials = [
  { icon: 'twitter', href: 'https://x.com/atharvuntwale20' },
  { icon: 'linkedin', href: 'https://www.linkedin.com/in/atharv-untwale/' },
  { icon: 'github', href: 'https://github.com/Atharv-Untwale' },
  { icon: 'instagram', href: 'https://www.instagram.com/atharvuntwale/?hl=en' }
];

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      // 1. Save to MongoDB via backend
      const backendRes = await fetch(`${API_URL}/api/contact`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
      });

      if (!backendRes.ok) {
        throw new Error('Failed to save message to database');
      }

      // 2. Send email via EmailJS
      await emailjs.send(
        'service_q07lwmj',
        'template_nnfjth9',
        {
          name: formData.name,
          email: formData.email,
          title: formData.subject,
          message: formData.message
        },
        'pBKzXW0gnWv62BxVH'
      );

      setSubmitted(true);
      setFormData({ name: '', email: '', subject: '', message: '' });
      setTimeout(() => setSubmitted(false), 5000);

    } catch (err) {
      console.error('Contact form error:', err);
      setError('Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const getInfoIcon = (type) => {
    if (type === 'email') return <FaEnvelope />;
    if (type === 'phone') return <FaPhone />;
    if (type === 'location') return <FaMapMarkerAlt />;
    return null;
  };

  const getSocialIcon = (type) => {
    if (type === 'twitter') return <FaTwitter />;
    if (type === 'linkedin') return <FaLinkedin />;
    if (type === 'github') return <FaGithub />;
    if (type === 'instagram') return <FaInstagram />;
    return null;
  };

  return (
    <section id="contact" className="contact">
      <div className="contact-container">
        <h2 className="contact-title">
          Get In <span className="highlight-cyan">Touch</span>
        </h2>
        <p className="contact-subtitle">
          I'd love to hear from you. Send me a message and I'll get back to you as soon as possible.
        </p>

        <div className="contact-content">
          {/* Left Side */}
          <div className="contact-left">
            <div className="contact-info-card">
              <h3 className="contact-info-title">Contact Information</h3>
              <p className="contact-info-desc">
                Let's work together on your next project. Feel free to reach out anytime.
              </p>

              <div className="contact-info-list">
                {contactInfo.map((item, index) => (
                  <div key={index} className="contact-info-item">
                    <div className="contact-info-icon">{getInfoIcon(item.icon)}</div>
                    <div className="contact-info-text">
                      <h4>{item.title}</h4>
                      <p>{item.value}</p>
                    </div>
                  </div>
                ))}
              </div>

              <div className="contact-socials">
                {socials.map((social, index) => (
                  <a key={index} href={social.href} target="_blank" rel="noopener noreferrer" className="contact-social-icon">
                    {getSocialIcon(social.icon)}
                  </a>
                ))}
              </div>
            </div>
          </div>

          {/* Right Side */}
          <div className="contact-right">
            <div className="contact-form-card">
              {submitted ? (
                <div className="success-message">
                  <div className="success-icon">✓</div>
                  <h3>Message Sent!</h3>
                  <p>Thank you! I'll get back to you soon.</p>
                </div>
              ) : (
                <form onSubmit={handleSubmit} className="contact-form">
                  <div className="form-row">
                    <div className="form-group">
                      <label>Your Name</label>
                      <input type="text" name="name" value={formData.name} onChange={handleChange} placeholder="Your Name" required />
                    </div>
                    <div className="form-group">
                      <label>Your Email</label>
                      <input type="email" name="email" value={formData.email} onChange={handleChange} placeholder="yourmail@gmail.com" required />
                    </div>
                  </div>

                  <div className="form-group">
                    <label>Subject</label>
                    <input type="text" name="subject" value={formData.subject} onChange={handleChange} placeholder="Project Discussion" required />
                  </div>

                  <div className="form-group">
                    <label>Message</label>
                    <textarea name="message" value={formData.message} onChange={handleChange} placeholder="Tell me about your project..." rows="5" required />
                  </div>

                  {error && <p className="error-message">{error}</p>}

                  <button type="submit" className="submit-btn" disabled={loading}>
                    {loading ? <span>Sending...</span> : <><FaPaperPlane /> Send Message</>}
                  </button>
                </form>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Contact;